import React from "react";
import PropTypes from "prop-types";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Configuration from "../../../config";

import Modal from "../../../components/Modal";
import Logo from "./Logo";
import Icon from "../../../components/Icon";

/**
 * Komponente um statische Inhalte auszugeben
 */
class OrderableQuestionnaires extends React.Component
{
	render()
	{
		const { questionnaires } = { ...this.props };
		const basicPriceInfo = !!this.props.basicPriceInfo;
		const statusInfo = !!this.props.statusInfo;
		
		return (
			// Prüfung um die Transition zu sehen
			questionnaires && Object.keys( questionnaires ).length > 0 &&
			<div className={"col s12 unset-padding"}>
				<h3>Verfügbare Einstufungsassistenten</h3>
				<div className={"col s12 light-blue unset-padding margin-top relative"}>
					<div className={"tLabel tRight secondary-color white-text"}>alle Preise zzgl. 19% Ust.</div>
					<ReactCSSTransitionGroup
						component={React.Fragment}
						transitionName="easeIn"
						transitionAppear={true}
						transitionAppearTimeout={500}
						transitionEnter={false}
						transitionLeave={false}>
						<div className={"col s12 surveyButtons"}>
							{
								questionnaires !== null && Object.keys( questionnaires ).length > 0 &&
								Object.keys( questionnaires ).map(
									( a_key ) =>
									{
										const link = questionnaires[a_key];
										const price = link.price > 0
											? ( parseFloat( link.price ) ).toLocaleString( Configuration.location, Configuration.priceString )
											: "NaN";
										
										return link.long_description
											? <Modal
												key={`questionnaires${a_key}`}
												title={link.description}
												trigger={
													<div className={"col s12 m6 l3 xl2"} key={`questionnaire_id_${link.id}`}>
														<div
															className={`col s12 white margin-bottom tCenter${statusInfo ? link.active === "1" ? " orderable" : " unorderable" : ""}`}>
															<div className={"priceLabel"}>{link.description}</div>
															<button key={`btn-flat primary-color-text hover-secondary-color-text questionnaire_open_id_${link.id}`}
															        className={"btn btn-rounded btn-pulse svg"}
															        title={"Recherchenbeschreibung anzeigen"}
															>
																<Logo topText={link.law} bottomText={link.title} id={link.id}/>
															</button>
															<div className={"price big-block"}>
																<div className={"cleared"}/>
																<span className={"value small"}>
																{price}
															</span>
																<span className={"additional"}>Euro
																	{
																		basicPriceInfo &&
																		<span className="form-element-required secondary-color-text">*</span>
																	}
															</span>
															</div>
														</div>
													</div>
												}
												footer={
													<React.Fragment>
														<span className={"secondary-color"} data-modal={"close"}>
															<Icon iconName={"discard"}/><span>Schließen</span>
														</span>
													</React.Fragment>
												}
											>
												<div className={"tRight dialogPrice"}>
														<span className={"value sub"}>
															{link.price && ( parseFloat( link.price ) ).toLocaleString( Configuration.location, Configuration.priceString )}
														</span>
													<span className={"additional"}> Euro</span>
													<div className={"cleared"}/>
													<label>Preis pro Recherche zzgl. 19% USt.</label>
												</div>
												<section className={"white"}>
													<div dangerouslySetInnerHTML={{ __html: link.long_description }}/>
												</section>
											</Modal>
											: <div className={"col s12 m6 l3 xl2"} key={`questionnaire_id_${link.id}`}>
												<div className={`col s12 white margin-bottom tCenter${statusInfo ? link.active === "1" ? " orderable" : " unorderable" : ""}`}>
													<div className={"priceLabel"}>{link.description}</div>
													<div key={`questionnaire_open_id_${link.id}`}
													     className={"btn btn-rounded svg cursor-default"}
													     title={link.description}
													>
														<Logo topText={link.law} bottomText={link.title} id={link.id}/>
													</div>
													<div className={"price big-block"}>
														<div className={"cleared"}/>
														<span className={"value small"}>
																{price}
															</span>
														<span className={"additional"}>Euro
															{
																basicPriceInfo &&
																<span className="form-element-required secondary-color-text">*</span>
															}
															</span>
													</div>
												</div>
											</div>;
									}
								)
							}
							{
								basicPriceInfo &&
								<label className={"col s12 margin-bottom secondary-color-text"}>
									<span className="form-element-required secondary-color-text">* </span>
									Nutzungsabhängige Gebühr pro durchgeführter Richtlinienrecherche, nur in Verbindung mit der monatlichen Imera Grundgebühr von 19,99 Euro.
									Alle Preise verstehen sich zuzüglich 19% USt.
								</label>
							}
						</div>
					</ReactCSSTransitionGroup>
				</div>
				<label>Ausführliche Beschreibung des Einstufungsassistenten erhalten Sie durch einen Klick auf den Assistenten.</label>
				<div className={"cleared spacer"}/>
			</div>
		);
		
	} // function render()
	
} // class

OrderableQuestionnaires.propTypes = {
	questionnaires: PropTypes.object.isRequired,
	basicPriceInfo: PropTypes.bool,
	statusInfo: PropTypes.bool
};

export default OrderableQuestionnaires;